import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Helmet} from 'react-helmet';
import queryString from 'query-string';
import {diff} from 'deep-object-diff';

import {getProfiles} from 'reducers/profiles';

import 'sass/profiles.scss';
import 'sass/members.scss';

import HeaderProfiles from 'components/profiles/HeaderProfiles';
import ProfilesItem from 'components/profiles/ProfilesItem';
import Pagination from "components/Pagination";
import Footer from 'components/Footer';

import {PROFILES_PER_PAGE} from '../constants/profiles';
import {t, dt} from 'l10n';

const PAGE_NUM_LIMIT = 1000;

import paths from 'paths';
import Loading from 'components/Loading';

class ProfilesContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: this.constructor.getSearchObject(props)
        };

        this.paginationUrlFn = this.paginationUrlFn.bind(this);
    }

    toggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    paginationUrlFn(page) {
        const {search} = this.state;
        return {
            pathname: paths.profiles.toPath({ query: search.query }),
            search: queryString.stringify({ ...search, page })
        }
    }

    static getSearchObject({location}) {
        return queryString.parse(location.search);
    }

    static fetchData({dispatch, location, match, params}) {
        const searchObj = this.getSearchObject({location, match});
    
        const reducerParams = {
            ...searchObj,
            limit: PROFILES_PER_PAGE,
            offset: ((searchObj.page || 1) - 1) * PROFILES_PER_PAGE,
            ...params
        };

        return dispatch(getProfiles(reducerParams));
    }

    componentDidMount() {
        let {dispatch, location, profiles, match} = this.props;

        let newSearchObj = this.constructor.getSearchObject(this.props);

        if (!profiles.list || Object.keys(diff(this.state.search, newSearchObj)).length) {
            this.constructor.fetchData({dispatch, location, match});
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            search: this.constructor.getSearchObject(nextProps)
        });
    }

    componentWillUpdate(nextProps, nextState) {
        let searchDiff = diff(this.state.search, nextState.search);
        if (Object.keys(searchDiff).length) {
            let {dispatch, location, match} = nextProps;

            this.constructor.fetchData({dispatch, location, match});
        }
    }

    render() {
        const {search} = this.state;
        let profiles = this.props.profiles;
        let list = profiles && profiles.list ? profiles.list : null;
        let totalCount = profiles && profiles.totalCount ? profiles.totalCount : 0;
        let paginationTotalCount = totalCount ? totalCount : PROFILES_PER_PAGE * PAGE_NUM_LIMIT;
        let currentPage = this.state.search.page || 1;

        return (
            <div id="wrapper">
                <Helmet>
                    <title>
                        {search.query ? `${search.query} - ${dt('meta', 'results for searching of members - BobTV')}`
                            : dt('meta', 'List of members of the chat of exhib on cam')
                        }
                    </title>
                    <meta name="description"
                          content={dt('meta', 'Search among bobTV members, exhibitionists, voyeurs, libertines or swingers.')}/>
                </Helmet>

                <HeaderProfiles search={this.state.search}/>

                <aside className="profiles">
                    <div className="content">
                        <h2>{t('Member search results')} <span>{totalCount}</span></h2>
                        <div className="profile-list ui-responsive-grid">
                            {list ?
                                list.map((profile) => <ProfilesItem key={profile.nick} profile={profile}/>)
                                :
                                <Loading/>
                            }
                        </div>
                        <Pagination
                            currentPage={currentPage}
                            itemsPerPage={PROFILES_PER_PAGE}
                            totalCount={paginationTotalCount}
                            urlFn={this.paginationUrlFn}
                            pageNumLimit={PAGE_NUM_LIMIT}
                        />
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        profiles: state.profiles
    }),
    null
)(ProfilesContainer)


// WEBPACK FOOTER //
// ./src/containers/Profiles.js